import React from 'react';
import moment from 'moment';
import 'moment/locale/es';
import { useSelector } from 'react-redux';

export const PlanDePagos = () => {

    const {total: totalPagado, list: {0: anticipo}} = useSelector(state => state.payments);
    const {costoPaquete, fecha_registro, paquete: {liquidacion_normal}} = useSelector(state => state.client); 
    let cantAnticipo = 0;


    const items = []

    if(anticipo) {
       const  {cantidad, fecha_pago} = anticipo;
       cantAnticipo = parseFloat(cantidad);
       items.push({
            noMes: 0,
            fecha: 'Anticipo',
            cantidad: cantidad,
            saldo: '',
            status: 'verified'
        })
    }
    
    const fechaFinal = moment(liquidacion_normal,"YYYY-MM-DD");
    let fechaInicio = '';
    if(anticipo) fechaInicio = moment(anticipo.fecha_pago);
    else fechaInicio = moment(fecha_registro);
    const meses = Math.ceil(moment(fechaFinal).diff(moment(fechaInicio), 'months', true));
    const mesActula = moment().format('YYYY-MM-DD');
    const mensualidad = Math.ceil( (costoPaquete - cantAnticipo)/meses );
    
    for (let i = 1; i <= meses; i++) {
        const requerido = i !== meses ? (mensualidad*i)+cantAnticipo : costoPaquete;
        const mesFor = moment(fechaInicio).add(i-1, 'month');
        const status = totalPagado >= requerido 
                                    ? 'verified' 
                                    : i !== meses 
                                        ? moment(mesFor).isBefore(mesActula, 'month') 
                                            ? 'report' 
                                            : false 
                                        : moment(mesFor).format('MM') == moment(mesActula).format('MM')
                                            ? 'report'
                                            : false ;
        const cantidad = i !== meses ? mensualidad : costoPaquete-(mensualidad*(i-1))-cantAnticipo;
        items.push({
            noMes: i,
            fecha: i !== meses ? moment(fechaInicio).add(i, 'month').format('MMMM YYYY') : moment(fechaFinal).format('LL'),
            cantidad,
            saldo: new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"}).format( requerido<totalPagado 
                ? 0
                : requerido-totalPagado > cantidad ? cantidad : requerido-totalPagado
            ),
            status
        })
        
    }

    if(totalPagado > 0)
        return (
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Plan de pagos</h5>
                    <p>
                        El siguiente desglose es una guía para mejorar el control de tus pagos que toma en cuenta el costo total de tu viaje dividido entre los meses que faltan para ser liquidado.<br />
                        Puedes adelantar tus pagos y se asignarán a los meses correspondientes. En caso de no cubrir el monto total de tu mensualidad, en la última columna podrás ver la cantidad faltante para completar ese pago.
                    </p>
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr className="text-center">
                                    <th scope="col">Fecha Limite</th>
                                    <th scope="col">Cantidad</th>
                                    <th scope="col">Por Pagar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    items.map(item => (
                                        <tr key={ item.noMes }>
                                            <td className="text-center text-nowrap d-flex justify-content-center align-content-center">
                                            <span className={`material-icons ${item.status === 'report' ? 'text-warning' : 'text-success'}`} style={{fontSize: '2em'}}>{item.status}</span>
                                                {item.fecha}
                                            </td>
                                            <td className="text-right">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"}).format(item.cantidad)}</td>
                                            <td className="text-right">{item.saldo}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th className="text-right">Total:</th>
                                    <th className="text-right">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"}).format(costoPaquete)}</th>
                                    <th></th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>      
                </div>
            </div>
        )
    else 
        return (
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Plan de pagos</h5>
                    <h5 className="text-warning">
                        El plan de pago se generara despues de ingresar tu anticipo.
                    </h5>     
                </div>
            </div>
        )
}
